var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "reset" }, [
    _vm._m(0),
    _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "flex-direction": "column",
          gap: "5px",
        },
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "align-items": "baseline",
              "justify-content": "space-between",
              position: "relative",
            },
          },
          [
            _c("div", { staticClass: "dot dot1 on" }),
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "1.2em",
                  "font-weight": "bold",
                  color: "#FF6600",
                },
              },
              [_vm._v("Tell us what you're studying or curious about:")]
            ),
            _c(
              "fieldset",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  gap: "10px",
                },
              },
              [
                _c("div", [_vm._v("mode:")]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      gap: "5px",
                    },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchMode,
                          expression: "searchMode",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        id: "search_auto",
                        name: "search_mode",
                        value: "auto",
                      },
                      domProps: { checked: _vm._q(_vm.searchMode, "auto") },
                      on: {
                        change: function ($event) {
                          _vm.searchMode = "auto"
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "search_auto" } }, [
                      _vm._v("auto "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              value:
                                "Allow this tool to run automatically to the end.",
                              expression:
                                "'Allow this tool to run automatically to the end.'",
                              modifiers: { hover: true },
                            },
                          ],
                          staticClass: "info-icon",
                        },
                        [_vm._v("?")]
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      gap: "5px",
                    },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchMode,
                          expression: "searchMode",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        id: "seach_step",
                        name: "search_mode",
                        value: "step",
                      },
                      domProps: { checked: _vm._q(_vm.searchMode, "step") },
                      on: {
                        change: function ($event) {
                          _vm.searchMode = "step"
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "seach_step" } }, [
                      _vm._v("step "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              value:
                                "Tool will pause and confirm with you at each step before proceeding.",
                              expression:
                                "'Tool will pause and confirm with you at each step before proceeding.'",
                              modifiers: { hover: true },
                            },
                          ],
                          staticClass: "info-icon",
                        },
                        [_vm._v("?")]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]
        ),
        _c("div", { staticStyle: { display: "flex", gap: "10px" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userQuery,
                expression: "userQuery",
              },
            ],
            ref: "query",
            staticStyle: { flex: "1", padding: "10px" },
            attrs: { type: "textarea", placeholder: "" },
            domProps: { value: _vm.userQuery },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.userQuery = $event.target.value
              },
            },
          }),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              staticStyle: { width: "200px" },
              on: {
                click: function ($event) {
                  return _vm.queryParse(_vm.$refs.query.value)
                },
              },
            },
            [_vm._v("Search")]
          ),
        ]),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              gap: "5px",
              "align-items": "center",
              "justify-content": "space-between",
            },
          },
          [
            _c(
              "a",
              {
                attrs: { role: "button" },
                on: {
                  click: function ($event) {
                    _vm.display_examples = !_vm.display_examples
                  },
                },
              },
              [
                _vm._v(
                  _vm._s(!_vm.display_examples ? "show" : "hide") + " examples"
                ),
              ]
            ),
            _c(
              "fieldset",
              {
                staticStyle: {
                  display: "none",
                  "align-items": "center",
                  gap: "10px",
                },
              },
              [
                _c("div", [_vm._v("(DEV) semantic api:")]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      gap: "5px",
                    },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchApi,
                          expression: "searchApi",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        id: "search_phenotypes",
                        name: "seach_type",
                        value: "old",
                      },
                      domProps: { checked: _vm._q(_vm.searchApi, "old") },
                      on: {
                        change: function ($event) {
                          _vm.searchApi = "old"
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "search_phenotypes" } }, [
                      _vm._v("old "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              value:
                                "Runs semantic search against phenotypes, then gets associated gene-sets for each.",
                              expression:
                                "'Runs semantic search against phenotypes, then gets associated gene-sets for each.'",
                              modifiers: { hover: true },
                            },
                          ],
                          staticClass: "info-icon",
                          staticStyle: { display: "none" },
                        },
                        [_vm._v("?")]
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      gap: "5px",
                    },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchApi,
                          expression: "searchApi",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        id: "seach_terms",
                        name: "seach_type",
                        value: "new",
                      },
                      domProps: { checked: _vm._q(_vm.searchApi, "new") },
                      on: {
                        change: function ($event) {
                          _vm.searchApi = "new"
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "seach_terms" } }, [
                      _vm._v("new "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              value:
                                "Runs semantic search against phenotype/gene-set associations.",
                              expression:
                                "'Runs semantic search against phenotype/gene-set associations.'",
                              modifiers: { hover: true },
                            },
                          ],
                          staticClass: "info-icon",
                          staticStyle: { display: "none" },
                        },
                        [_vm._v("?")]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]
        ),
        _c(
          "div",
          {
            class: { collapsed: !_vm.display_examples },
            staticStyle: { display: "flex", gap: "10px" },
          },
          _vm._l(_vm.exampleQueries, function (example) {
            return _c(
              "div",
              {
                staticClass: "query-sample",
                on: {
                  click: function ($event) {
                    return _vm.useExample(example)
                  },
                },
              },
              [_vm._v(_vm._s(example))]
            )
          }),
          0
        ),
      ]
    ),
    _c("div", { staticStyle: { position: "relative" } }, [
      _c("div", { staticClass: "dot dot2" }),
      _vm.search_step < 1
        ? _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                gap: "5px",
                "min-height": "75px",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "1.2em",
                    "font-weight": "bold",
                    color: "#FF6600",
                  },
                },
                [_vm._v("We'll understand your query.")]
              ),
              _vm._m(1),
            ]
          )
        : _vm._e(),
      _vm.search_step >= 1
        ? _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                gap: "10px",
              },
            },
            [
              _vm.loading_search_criteria
                ? _c(
                    "div",
                    {
                      staticClass: "loading-text",
                      staticStyle: {
                        display: "flex",
                        "align-items": "baseline",
                        gap: "5px",
                        "min-height": "75px",
                      },
                    },
                    [
                      _vm._m(2),
                      _vm.elapsed
                        ? _c("div", { staticStyle: { "font-size": "1em" } }, [
                            _vm._v(
                              _vm._s(`${_vm.elapsed}`) +
                                " (usually takes about 30 seconds)"
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm.error_search_criteria
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "baseline",
                        gap: "5px",
                        "min-height": "75px",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { "font-size": "1.2em", color: "red" } },
                        [
                          _c("strong", [_vm._v("Error:")]),
                          _vm._v(" " + _vm._s(_vm.error_msg_search_criteria)),
                        ]
                      ),
                      _vm.allow_retry
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-primary",
                              on: {
                                click: function ($event) {
                                  return _vm.beginFlow()
                                },
                              },
                            },
                            [_vm._v("Retry")]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm.searchCriteria
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        gap: "5px",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "1.2em",
                            "font-weight": "bold",
                            color: "#FF6600",
                          },
                        },
                        [_vm._v("Extracted research criteria from your Query")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "section-header",
                          on: {
                            click: function ($event) {
                              _vm.display_search_criteria =
                                !_vm.display_search_criteria
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "grid",
                                gap: "5px",
                                width: "calc(100% - 200px)",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "grid",
                                    "grid-template-columns": "170px auto",
                                    gap: "5px",
                                  },
                                },
                                [
                                  _c("strong", [_vm._v("Search Terms: ")]),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "flex-wrap": "wrap",
                                        gap: "5px",
                                      },
                                    },
                                    _vm._l(
                                      _vm.searchCriteria[0].values,
                                      function (item) {
                                        return _c(
                                          "span",
                                          { staticClass: "pill" },
                                          [_vm._v(_vm._s(item))]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "grid",
                                    "grid-template-columns": "170px auto",
                                    gap: "5px",
                                  },
                                },
                                [
                                  _c("strong", [
                                    _vm._v("Your Research Context: "),
                                  ]),
                                  _c("span", { staticClass: "pill" }, [
                                    _vm._v(
                                      _vm._s(_vm.searchCriteria[1].values)
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "section-header-state" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  !_vm.display_search_criteria
                                    ? "show more"
                                    : "show less"
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  class: {
                    collapsed: !_vm.display_search_criteria,
                    editing: _vm.edit_search_criteria,
                  },
                  staticStyle: {
                    padding: "0 40px",
                    display: "flex",
                    "flex-direction": "column",
                    gap: "10px",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        "justify-content": "flex-end",
                      },
                    },
                    [
                      !_vm.edit_search_criteria
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-info",
                              on: {
                                click: function ($event) {
                                  return _vm.editSearchCriteria()
                                },
                              },
                            },
                            [_vm._v("✎ Edit search criteria")]
                          )
                        : _vm._e(),
                      _vm.edit_search_criteria
                        ? _c(
                            "div",
                            { staticStyle: { display: "flex", gap: "5px" } },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-warning",
                                  on: {
                                    click: function ($event) {
                                      return _vm.cancelEditSearchCriteria()
                                    },
                                  },
                                },
                                [_vm._v("Cancel")]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-success",
                                  on: {
                                    click: function ($event) {
                                      return _vm.saveSearchCriteria()
                                    },
                                  },
                                },
                                [_vm._v("Save search criteria")]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._m(3),
                  _c("b-table", {
                    attrs: {
                      items: _vm.searchCriteria,
                      small: "",
                      striped: "",
                      hover: "",
                      responsive: "sm",
                      "head-variant": "light",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "cell(values)",
                          fn: function (row) {
                            return [
                              Array.isArray(row.item.values)
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "inline-flex",
                                        gap: "5px",
                                        "flex-wrap": "wrap",
                                      },
                                    },
                                    [
                                      _vm._l(row.item.values, function (item) {
                                        return _c(
                                          "span",
                                          {
                                            staticClass: "pill",
                                            class: {
                                              editable:
                                                _vm.edit_search_criteria,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeSearchTerm(
                                                  item
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(item))]
                                        )
                                      }),
                                      _vm.edit_search_criteria
                                        ? _c("input", {
                                            staticClass: "pill new",
                                            attrs: { placeholder: "+" },
                                            on: {
                                              keyup: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                return _vm.addSearchTerm($event)
                                              },
                                              blur: function ($event) {
                                                return _vm.addSearchTerm($event)
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                : _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: row.item.values,
                                        expression: "row.item.values",
                                      },
                                    ],
                                    staticClass: "pill",
                                    staticStyle: {
                                      width: "100%",
                                      "field-sizing": "content",
                                    },
                                    attrs: {
                                      id: "context-edit-1",
                                      disabled: !_vm.edit_search_criteria,
                                    },
                                    domProps: { value: row.item.values },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          row.item,
                                          "values",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                            ]
                          },
                        },
                        {
                          key: "cell(why)",
                          fn: function (data) {
                            return [
                              _c("span", {
                                domProps: { innerHTML: _vm._s(data.value) },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      939871011
                    ),
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        "justify-content": "flex-end",
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: {
                            disabled:
                              _vm.edit_search_criteria ||
                              _vm.search_step > 1 ||
                              (_vm.search_step > 1 &&
                                !_vm.user_edited_search_criteria),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.associationSearch(_vm.searchTerm)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.searchMode === "step"
                                  ? "Continue"
                                  : "Re-search"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ]),
    _c("div", { staticStyle: { position: "relative" } }, [
      _c("div", { staticClass: "dot dot3" }),
      _vm.search_step < 2
        ? _c(
            "div",
            {
              class: { muted: _vm.search_step > 0 },
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                gap: "5px",
                position: "relative",
                "min-height": "75px",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "1.2em",
                    "font-weight": "bold",
                    color: "#FF6600",
                  },
                },
                [_vm._v("Retrieve relevant associations.")]
              ),
              _c("div", [
                _c("div", [
                  _vm._v(
                    "Our associations contain over 6,000 common & rare disease phenotypes and 150,000 signatures."
                  ),
                ]),
                _c("div", [
                  _vm._v("We use "),
                  _c(
                    "a",
                    {
                      attrs: { role: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.showByorTab()
                        },
                      },
                    },
                    [_vm._v("semantic search")]
                  ),
                  _vm._v(
                    " to find those most relevant, and gather the strongest links."
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm.search_step >= 2
        ? _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                gap: "10px",
              },
            },
            [
              _vm.loading_associations
                ? _c(
                    "div",
                    {
                      staticClass: "loading-text",
                      staticStyle: {
                        display: "flex",
                        gap: "10px",
                        "min-height": "75px",
                      },
                    },
                    [
                      _c("div", { staticStyle: { "font-size": "1.2em" } }, [
                        _c("strong", [_vm._v("Action:")]),
                        _vm._v(
                          " Searching for phenotype↔signature associations related to "
                        ),
                        _c("strong", [_vm._v(_vm._s(_vm.searchTerm))]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.error_associations
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "baseline",
                        gap: "5px",
                        "min-height": "75px",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { "font-size": "1.2em", color: "red" } },
                        [
                          _c("strong", [_vm._v("Error:")]),
                          _vm._v(" " + _vm._s(_vm.error_msg_associations)),
                        ]
                      ),
                      _vm.allow_retry
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-primary",
                              on: {
                                click: function ($event) {
                                  return _vm.associationSearch(_vm.searchTerm)
                                },
                              },
                            },
                            [_vm._v("Retry")]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm.associations && _vm.relevantAssociations
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        gap: "5px",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "1.2em",
                            "font-weight": "bold",
                            color: "#FF6600",
                          },
                        },
                        [
                          _vm._v("Found "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.associations.length) +
                                " phenotype↔signature"
                            ),
                          ]),
                          _vm._v(" associations related to the Search Terms"),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "section-header",
                          on: {
                            click: function ($event) {
                              _vm.display_associations =
                                !_vm.display_associations
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "max-width": "calc(100% - 200px)",
                              },
                            },
                            [
                              _vm._v("Across "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.total_phenotypes) + " phenotypes"
                                ),
                              ]),
                              _vm._v(", "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.total_signatures) +
                                    " expression signatures"
                                ),
                              ]),
                              _vm._v(", and "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.total_programs) + " CFDE programs"
                                ),
                              ]),
                              _vm._v("."),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "max-width": "calc(100% - 200px)",
                              },
                            },
                            [
                              _vm._v("Selected "),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.relevantAssociations.length)),
                              ]),
                              _vm._v(" associations. "),
                            ]
                          ),
                          _c("div", { staticClass: "section-header-state" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  !_vm.display_associations
                                    ? "show more"
                                    : "show less"
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  class: { collapsed: !_vm.display_associations },
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    gap: "10px",
                    padding: "0 40px",
                  },
                },
                [
                  _c("div", { staticClass: "tab-handles" }, [
                    _c(
                      "div",
                      {
                        staticClass: "tab-handle",
                        class: { active: _vm.activeTab === 1 },
                        on: {
                          click: function ($event) {
                            _vm.activeTab = 1
                          },
                        },
                      },
                      [_vm._v("Table")]
                    ),
                    _vm.relevantAssociationsWithGenes
                      ? _c(
                          "div",
                          {
                            staticClass: "tab-handle",
                            class: { active: _vm.activeTab === 2 },
                            on: {
                              click: function ($event) {
                                _vm.activeTab = 2
                              },
                            },
                          },
                          [_vm._v("Visualization")]
                        )
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "tab-sections" }, [
                    _c(
                      "div",
                      {
                        staticClass: "tab-section",
                        class: { active: _vm.activeTab === 1 },
                      },
                      [
                        !_vm.user_selected_associations
                          ? _c("div", { staticClass: "note" }, [
                              _vm._v(
                                " By default, we sort the resulting associations by sematic similarity to the Search Terms, then use the top 300 associations for analysis."
                              ),
                              _c("br"),
                              _vm._v(
                                " You may change the associations selected for analysis by clicking "
                              ),
                              _c("strong", [
                                _vm._v("Edit Selected Associations"),
                              ]),
                              _vm._v(" button and choosing your own. "),
                            ])
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "flex-end",
                            },
                          },
                          [
                            !_vm.edit_associations
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-info",
                                    on: {
                                      click: function ($event) {
                                        return _vm.editAssociations()
                                      },
                                    },
                                  },
                                  [_vm._v("✎ Edit selected associations")]
                                )
                              : _vm._e(),
                            _vm.edit_associations
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      gap: "5px",
                                    },
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-warning",
                                        on: {
                                          click: function ($event) {
                                            return _vm.cancelEditAssociations()
                                          },
                                        },
                                      },
                                      [_vm._v("Cancel")]
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-success",
                                        on: {
                                          click: function ($event) {
                                            return _vm.saveAssociations()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "Apply " +
                                            _vm._s(
                                              _vm.temp_selected_associations
                                            ) +
                                            " selected associations"
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm.edit_associations
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "flex-direction": "column",
                                  gap: "10px",
                                  padding: "10px",
                                  border: "1px solid #ccc",
                                  "border-radius": "10px",
                                  margin: "10px 0",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      gap: "20px",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "flex-direction": "column",
                                          width: "120px",
                                          gap: "5px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "font-weight": "bold",
                                            },
                                          },
                                          [_vm._v("Select")]
                                        ),
                                        _c(
                                          "div",
                                          { staticStyle: { height: "100px" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.temp_selected_associations
                                              ) +
                                                " of " +
                                                _vm._s(
                                                  _vm.associations.length
                                                ) +
                                                " associations selected"
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              gap: "10px",
                                            },
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-sm btn-outline-dark",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.selectAll()
                                                  },
                                                },
                                              },
                                              [_vm._v("All")]
                                            ),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-sm btn-outline-dark",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deselectAll()
                                                  },
                                                },
                                              },
                                              [_vm._v("None")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "flex-direction": "column",
                                          flex: "1",
                                          gap: "5px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v("Phenotypes"),
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  `${_vm.filtered_phenotypes.length}/${_vm.phenotypes_list.length}`
                                                )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              height: "100px",
                                              display: "flex",
                                              "flex-direction": "column",
                                              gap: "3px",
                                              overflow: "auto",
                                              background: "#eee",
                                              padding: "5px 10px",
                                            },
                                          },
                                          _vm._l(
                                            _vm.phenotypes_list,
                                            function (option, idx) {
                                              return _c(
                                                "div",
                                                {
                                                  key: option,
                                                  staticStyle: {
                                                    display: "flex",
                                                    gap: "5px",
                                                  },
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.filtered_phenotypes,
                                                        expression:
                                                          "filtered_phenotypes",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "checkbox",
                                                      id: `phenotype_${idx}`,
                                                    },
                                                    domProps: {
                                                      value: option,
                                                      checked: Array.isArray(
                                                        _vm.filtered_phenotypes
                                                      )
                                                        ? _vm._i(
                                                            _vm.filtered_phenotypes,
                                                            option
                                                          ) > -1
                                                        : _vm.filtered_phenotypes,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            _vm.filtered_phenotypes,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = option,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.filtered_phenotypes =
                                                                $$a.concat([
                                                                  $$v,
                                                                ]))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.filtered_phenotypes =
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  ))
                                                          }
                                                        } else {
                                                          _vm.filtered_phenotypes =
                                                            $$c
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: `phenotype_${idx}`,
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(option))]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "flex-direction": "column",
                                          width: "300px",
                                          gap: "5px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v("Association strength"),
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  `${_vm.filtered_association_strengths.length}/${_vm.association_strengths_list.length}`
                                                )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              height: "100px",
                                              display: "flex",
                                              "flex-direction": "column",
                                              gap: "3px",
                                              overflow: "auto",
                                              background: "#eee",
                                              padding: "5px 10px",
                                            },
                                          },
                                          _vm._l(
                                            _vm.association_strengths_list,
                                            function (option, idx) {
                                              return _c(
                                                "div",
                                                {
                                                  key: idx,
                                                  staticStyle: {
                                                    display: "flex",
                                                    gap: "5px",
                                                  },
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.filtered_association_strengths,
                                                        expression:
                                                          "filtered_association_strengths",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "checkbox",
                                                      id: `strength_${idx}`,
                                                      disabled:
                                                        option.total === 0,
                                                    },
                                                    domProps: {
                                                      value: idx,
                                                      checked: Array.isArray(
                                                        _vm.filtered_association_strengths
                                                      )
                                                        ? _vm._i(
                                                            _vm.filtered_association_strengths,
                                                            idx
                                                          ) > -1
                                                        : _vm.filtered_association_strengths,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            _vm.filtered_association_strengths,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = idx,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.filtered_association_strengths =
                                                                $$a.concat([
                                                                  $$v,
                                                                ]))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.filtered_association_strengths =
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  ))
                                                          }
                                                        } else {
                                                          _vm.filtered_association_strengths =
                                                            $$c
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "justify-content":
                                                          "space-between",
                                                        width: "100%",
                                                      },
                                                      style: `opacity:${
                                                        option.total === 0
                                                          ? "0.5"
                                                          : "1"
                                                      }`,
                                                      attrs: {
                                                        for: `strength_${idx}`,
                                                      },
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(option.label)
                                                        ),
                                                      ]),
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(option.text)
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "flex-direction": "column",
                                          width: "300px",
                                          gap: "5px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c("strong", [_vm._v("Sources")]),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  `${_vm.filtered_programs.length}/${_vm.programs_list.length}`
                                                )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              height: "100px",
                                              display: "flex",
                                              "flex-direction": "column",
                                              gap: "3px",
                                              overflow: "auto",
                                              background: "#eee",
                                              padding: "5px 10px",
                                            },
                                          },
                                          _vm._l(
                                            _vm.programs_list,
                                            function (option, idx) {
                                              return _c(
                                                "div",
                                                {
                                                  key: option,
                                                  staticStyle: {
                                                    display: "flex",
                                                    gap: "5px",
                                                  },
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.filtered_programs,
                                                        expression:
                                                          "filtered_programs",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "checkbox",
                                                      id: `program_${idx}`,
                                                    },
                                                    domProps: {
                                                      value: option,
                                                      checked: Array.isArray(
                                                        _vm.filtered_programs
                                                      )
                                                        ? _vm._i(
                                                            _vm.filtered_programs,
                                                            option
                                                          ) > -1
                                                        : _vm.filtered_programs,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            _vm.filtered_programs,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = option,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.filtered_programs =
                                                                $$a.concat([
                                                                  $$v,
                                                                ]))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.filtered_programs =
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  ))
                                                          }
                                                        } else {
                                                          _vm.filtered_programs =
                                                            $$c
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: `program_${idx}`,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          option.replace(
                                                            ";",
                                                            " x "
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "1.2em",
                                  "font-weight": "bold",
                                },
                              },
                              [
                                _vm._v("All associations for "),
                                _c("em", [_vm._v(_vm._s(_vm.searchTerm))]),
                              ]
                            ),
                          ]
                        ),
                        _c("b-table", {
                          attrs: {
                            items: _vm.associations,
                            fields: [
                              {
                                key: "selected",
                                label: "Select",
                                thStyle: { width: "70px" },
                              },
                              {
                                key: "phenotype",
                                label: "Phenotype",
                                sortable: true,
                              },
                              {
                                key: "score",
                                label: "Similarity Score",
                                sortable: true,
                              },
                              {
                                key: "beta_uncorrected",
                                label: "Effect (beta uncorrected)",
                                sortable: true,
                              },
                              {
                                key: "gene_set_label",
                                label: "Signature (gene set)",
                              },
                              {
                                key: "source_label",
                                label: "Source",
                                sortable: true,
                              },
                              "actions",
                            ],
                            small: "",
                            striped: "",
                            hover: "",
                            responsive: "sm",
                            "head-variant": "light",
                            "sticky-header": "400px",
                            "sort-icon-left": "",
                            "sort-by": "score",
                            "sort-desc": true,
                            "show-details": "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "head(selected)",
                                fn: function (data) {
                                  return [
                                    _vm._v(" " + _vm._s(data.label) + " "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            value:
                                              "Include this association in mechanistic discovery.",
                                            expression:
                                              "'Include this association in mechanistic discovery.'",
                                            modifiers: { hover: true },
                                          },
                                        ],
                                        staticClass: "info-icon",
                                      },
                                      [_vm._v("?")]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "head(phenotype)",
                                fn: function (data) {
                                  return [
                                    _vm._v(" " + _vm._s(data.label) + " "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            value:
                                              "The trait or condition linked to the genes in this signature.",
                                            expression:
                                              "'The trait or condition linked to the genes in this signature.'",
                                            modifiers: { hover: true },
                                          },
                                        ],
                                        staticClass: "info-icon",
                                      },
                                      [_vm._v("?")]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "head(score)",
                                fn: function (data) {
                                  return [
                                    _vm._v(" " + _vm._s(data.label) + " "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            value:
                                              "Semantic similarity of search terms to phenotype & signature. Range is form -1 to 1, being least to most similar.",
                                            expression:
                                              "'Semantic similarity of search terms to phenotype & signature. Range is form -1 to 1, being least to most similar.'",
                                            modifiers: { hover: true },
                                          },
                                        ],
                                        staticClass: "info-icon",
                                      },
                                      [_vm._v("?")]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "head(beta_uncorrected)",
                                fn: function (data) {
                                  return [
                                    _vm._v(" " + _vm._s(data.label) + " "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            value:
                                              "How strongly the signature's genes overlap with the genes linked to the phenotype.",
                                            expression:
                                              "'How strongly the signature\\'s genes overlap with the genes linked to the phenotype.'",
                                            modifiers: { hover: true },
                                          },
                                        ],
                                        staticClass: "info-icon",
                                      },
                                      [_vm._v("?")]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "head(gene_set)",
                                fn: function (data) {
                                  return [
                                    _vm._v(" " + _vm._s(data.label) + " "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            value:
                                              "The set of genes that turned on or off in a specific dataset or experiment giving a snapshot of a biological state. The label encodes the source (e.g. dataset, tissue, condition) and whether genes are up- or down-regulated.",
                                            expression:
                                              "'The set of genes that turned on or off in a specific dataset or experiment giving a snapshot of a biological state. The label encodes the source (e.g. dataset, tissue, condition) and whether genes are up- or down-regulated.'",
                                            modifiers: { hover: true },
                                          },
                                        ],
                                        staticClass: "info-icon",
                                      },
                                      [_vm._v("?")]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "head(gene_set_label)",
                                fn: function (data) {
                                  return [
                                    _vm._v(" " + _vm._s(data.label) + " "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            value:
                                              "The set of genes that turned on or off in a specific dataset or experiment giving a snapshot of a biological state. The label encodes the source (e.g. dataset, tissue, condition) and whether genes are up- or down-regulated.",
                                            expression:
                                              "'The set of genes that turned on or off in a specific dataset or experiment giving a snapshot of a biological state. The label encodes the source (e.g. dataset, tissue, condition) and whether genes are up- or down-regulated.'",
                                            modifiers: { hover: true },
                                          },
                                        ],
                                        staticClass: "info-icon",
                                      },
                                      [_vm._v("?")]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "head(source)",
                                fn: function (data) {
                                  return [
                                    _vm._v(" " + _vm._s(data.label) + " "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            value:
                                              "Which CFDE program this signature came from so you know the context of the data.",
                                            expression:
                                              "'Which CFDE program this signature came from so you know the context of the data.'",
                                            modifiers: { hover: true },
                                          },
                                        ],
                                        staticClass: "info-icon",
                                      },
                                      [_vm._v("?")]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "head(source_label)",
                                fn: function (data) {
                                  return [
                                    _vm._v(" " + _vm._s(data.label) + " "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            value:
                                              "Which CFDE program this signature came from so you know the context of the data.",
                                            expression:
                                              "'Which CFDE program this signature came from so you know the context of the data.'",
                                            modifiers: { hover: true },
                                          },
                                        ],
                                        staticClass: "info-icon",
                                      },
                                      [_vm._v("?")]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "head(datasets)",
                                fn: function (data) {
                                  return [
                                    _vm._v(" " + _vm._s(data.label) + " "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            value:
                                              "Links to the datasets from which these signatures were generated.",
                                            expression:
                                              "'Links to the datasets from which these signatures were generated.'",
                                            modifiers: { hover: true },
                                          },
                                        ],
                                        staticClass: "info-icon",
                                      },
                                      [_vm._v("?")]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(selected)",
                                fn: function (row) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "text-align": "center" },
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: row.item.selected,
                                              expression: "row.item.selected",
                                            },
                                          ],
                                          attrs: {
                                            type: "checkbox",
                                            disabled: !_vm.edit_associations,
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              row.item.selected
                                            )
                                              ? _vm._i(
                                                  row.item.selected,
                                                  null
                                                ) > -1
                                              : row.item.selected,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.customSelect()
                                            },
                                            change: function ($event) {
                                              var $$a = row.item.selected,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      row.item,
                                                      "selected",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      row.item,
                                                      "selected",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  row.item,
                                                  "selected",
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(score)",
                                fn: function (row) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(row.item.score.toFixed(3)) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(beta_uncorrected)",
                                fn: function (row) {
                                  return [
                                    row.item.beta_uncorrected < 0.1
                                      ? _c("div", [
                                          _vm._v(
                                            "low (" +
                                              _vm._s(
                                                row.item.beta_uncorrected
                                              ) +
                                              ")"
                                          ),
                                        ])
                                      : _vm._e(),
                                    row.item.beta_uncorrected >= 0.1 &&
                                    row.item.beta_uncorrected < 1
                                      ? _c("div", [
                                          _vm._v(
                                            "moderate (" +
                                              _vm._s(
                                                row.item.beta_uncorrected
                                              ) +
                                              ")"
                                          ),
                                        ])
                                      : _vm._e(),
                                    row.item.beta_uncorrected >= 1
                                      ? _c("div", [
                                          _vm._v(
                                            "strong (" +
                                              _vm._s(
                                                row.item.beta_uncorrected
                                              ) +
                                              ")"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "cell(genes_in_set)",
                                fn: function (row) {
                                  return [
                                    row.item.genes && row.item.genes.length > 0
                                      ? _c(
                                          "button",
                                          { on: { click: row.toggleDetails } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  row.detailsShowing
                                                    ? "Hide"
                                                    : "Show"
                                                ) +
                                                " " +
                                                _vm._s(
                                                  (row.item.genes || []).length
                                                ) +
                                                " Genes "
                                            ),
                                          ]
                                        )
                                      : _c("div", [_vm._v("no results")]),
                                  ]
                                },
                              },
                              {
                                key: "cell(datasets)",
                                fn: function (row) {
                                  return [
                                    _c(
                                      "button",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.alert(
                                              "NEED: links to source datasets"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" View ")]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(actions)",
                                fn: function (row) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "flex-direction": "column",
                                        },
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.getsetLink(row.item),
                                              target: "_blank",
                                              disabled: "",
                                            },
                                          },
                                          [_vm._v("View Geneset")]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "row-details",
                                fn: function ({ item }) {
                                  return [
                                    _c("b-table", {
                                      attrs: {
                                        small: "",
                                        "sticky-header": "300px",
                                        items: item.genes,
                                        fields: [
                                          "gene",
                                          "combined",
                                          "beta",
                                          "beta_uncorrected",
                                          "log_bf",
                                          "prior",
                                          "trait_group",
                                        ],
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4223712527
                          ),
                        }),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "flex-end",
                            },
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  disabled:
                                    _vm.edit_associations ||
                                    _vm.search_step > 2 ||
                                    (_vm.search_step > 2 &&
                                      !_vm.user_selected_associations),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.mechanismsReveal()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.searchMode === "step"
                                        ? "Continue"
                                        : "Re-analyze"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "tab-section",
                        class: { active: _vm.activeTab === 2 },
                      },
                      [
                        _vm.relevantAssociationsWithGenes
                          ? _c("cfde-mechanism-heatmap", {
                              attrs: {
                                associations: _vm.relevantAssociationsWithGenes,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]),
    _c("div", { staticStyle: { position: "relative" } }, [
      _c("div", { staticClass: "dot dot4" }),
      _vm.search_step < 3
        ? _c(
            "div",
            {
              class: { muted: _vm.search_step > 0 },
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                gap: "5px",
                position: "relative",
                "min-height": "75px",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "1.2em",
                    "font-weight": "bold",
                    color: "#FF6600",
                  },
                },
                [_vm._v("Interpret the results.")]
              ),
              _vm._m(4),
            ]
          )
        : _vm._e(),
      _vm.search_step >= 3
        ? _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                gap: "10px",
              },
            },
            [
              _vm.loading_genes
                ? _c(
                    "div",
                    {
                      staticClass: "loading-text",
                      staticStyle: {
                        display: "flex",
                        gap: "5px",
                        "align-items": "baseline",
                        "min-height": "75px",
                      },
                    },
                    [
                      _vm._m(5),
                      _c("div", { staticStyle: { "font-size": "1em" } }, [
                        _vm._v(
                          _vm._s(_vm.association_genes_loaded) +
                            " / " +
                            _vm._s(_vm.relevantAssociations.length) +
                            " selected associations"
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.loading_mechanisms
                ? _c(
                    "div",
                    {
                      staticClass: "loading-text",
                      staticStyle: {
                        display: "flex",
                        gap: "5px",
                        "align-items": "baseline",
                        "min-height": "75px",
                      },
                    },
                    [
                      _vm._m(6),
                      _vm.elapsed
                        ? _c("div", { staticStyle: { "font-size": "1em" } }, [
                            _vm._v(
                              _vm._s(`${_vm.elapsed}`) +
                                " (usually takes about 1-2 minutes)"
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm.error_mechanisms
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "baseline",
                        gap: "5px",
                        "min-height": "75px",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { "font-size": "1.2em", color: "red" } },
                        [
                          _c("strong", [_vm._v("Error:")]),
                          _vm._v(" " + _vm._s(_vm.error_msg_mechanisms)),
                        ]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-primary",
                          on: {
                            click: function ($event) {
                              return _vm.mechanismsReveal()
                            },
                          },
                        },
                        [_vm._v("Retry")]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.mechanisms
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        gap: "5px",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "1.2em",
                            "font-weight": "bold",
                            color: "#FF6600",
                          },
                        },
                        [
                          _vm._v(
                            "Generated " +
                              _vm._s(_vm.mechanisms.length) +
                              " mechanistic hypotheses."
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "section-header",
                          on: {
                            click: function ($event) {
                              _vm.display_mechanisms = !_vm.display_mechanisms
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "max-width": "calc(100% - 200px)",
                              },
                            },
                            [
                              _vm._v("In the context of "),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.searchCriteria[1].values)),
                              ]),
                            ]
                          ),
                          _c("div", { staticClass: "section-header-state" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  !_vm.display_mechanisms
                                    ? "show more"
                                    : "show less"
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  class: {
                    collapsed: !_vm.display_mechanisms,
                    editing: _vm.edit_search_criteria,
                  },
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    gap: "5px",
                    padding: "0 40px",
                  },
                },
                [
                  _vm.mechanisms
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            gap: "20px",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "note",
                              staticStyle: { display: "flex", gap: "20px" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    flex: "1",
                                  },
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      "The following mechanistic hypotheses were generated using the selected associations in the context of:"
                                    ),
                                  ]),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.searchCriteria[1].values,
                                        expression: "searchCriteria[1].values",
                                      },
                                    ],
                                    staticClass: "pill",
                                    staticStyle: {
                                      width: "100%",
                                      height: "100%",
                                      "align-items": "center",
                                    },
                                    attrs: {
                                      id: "context-edit-2",
                                      disabled: !_vm.edit_context,
                                    },
                                    domProps: {
                                      value: _vm.searchCriteria[1].values,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.searchCriteria[1],
                                          "values",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    gap: "5px",
                                    "align-self": "flex-end",
                                  },
                                },
                                [
                                  !_vm.edit_context
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-info",
                                          on: {
                                            click: function ($event) {
                                              return _vm.editContext()
                                            },
                                          },
                                        },
                                        [_vm._v("✎ Edit context")]
                                      )
                                    : _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-warning",
                                          on: {
                                            click: function ($event) {
                                              return _vm.cancelEditContext()
                                            },
                                          },
                                        },
                                        [_vm._v("Cancel")]
                                      ),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary",
                                      attrs: { disabled: !_vm.edit_context },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mechanismsReveal()
                                        },
                                      },
                                    },
                                    [_vm._v("Re-analyze")]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "flex-end",
                              },
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary btn-sm",
                                  on: {
                                    click: function ($event) {
                                      return _vm.downloadHypotheses()
                                    },
                                  },
                                },
                                [_vm._v("Download Hypotheses")]
                              ),
                            ]
                          ),
                          _vm.mechanisms_summary
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    "margin-bottom": "20px",
                                  },
                                },
                                [
                                  _c(
                                    "strong",
                                    { staticStyle: { "font-size": "1.2em" } },
                                    [_vm._v("Summary:")]
                                  ),
                                  _c("div", [
                                    _vm._v(_vm._s(_vm.mechanisms_summary)),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "grid",
                                "grid-template-columns": "1fr",
                                gap: "40px",
                              },
                            },
                            _vm._l(_vm.mechanisms, function (mechanism) {
                              return _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    gap: "20px",
                                    border: "1px solid #ccc",
                                    "border-radius": "10px",
                                    "box-shadow":
                                      "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                                    background: "#eee",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        padding: "20px",
                                        background: "#ccc",
                                        margin: "-1px",
                                        "border-radius": "10px 10px 0px 0px",
                                        display: "flex",
                                        "flex-direction": "column",
                                        gap: "10px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-size": "1.2em",
                                            "line-height": "1.2em",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [_vm._v(_vm._s(mechanism.group_name))]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "grid",
                                        "grid-template-columns": "2fr 1fr",
                                        gap: "10px",
                                        padding: "0 20px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            padding: "5px",
                                            gap: "10px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-weight": "bold",
                                              },
                                            },
                                            [_vm._v("mechanistic hypothesis")]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-size": "1.1em",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(mechanism.hypothesis)
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            padding: "5px",
                                            height: "fit-content",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-size": ".8em",
                                                "font-weight": "bold",
                                                padding: "3px 0",
                                              },
                                            },
                                            [_vm._v("rationale")]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-size": "0.9em",
                                                background:
                                                  "rgb(251, 228, 186)",
                                                padding: "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  mechanism.novelty_explanation
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "grid",
                                        "grid-template-columns": "2fr 1fr",
                                        gap: "10px",
                                        padding: "0 20px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            padding: "5px",
                                            gap: "10px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-weight": "bold",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " candidate genes (" +
                                                  _vm._s(
                                                    mechanism.genes.length
                                                  ) +
                                                  ") "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                gap: "5px",
                                                "flex-wrap": "wrap",
                                              },
                                            },
                                            _vm._l(
                                              mechanism.genes,
                                              function (gene) {
                                                return _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "grid",
                                                      "grid-template-columns":
                                                        "100px auto",
                                                      gap: "20px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "pill" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(gene.gene)
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "0.9em",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(gene.reason)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            padding: "5px",
                                            height: "fit-content",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-size": ".8em",
                                                "font-weight": "bold",
                                                padding: "3px 0",
                                              },
                                            },
                                            [_vm._v("rationale")]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-size": "0.9em",
                                                background:
                                                  "rgb(251, 228, 186)",
                                                padding: "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(mechanism.genes_reason)
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "grid",
                                        "grid-template-columns": "2fr 1fr",
                                        gap: "10px",
                                        padding: "0 20px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            gap: "20px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-direction": "column",
                                                padding: "5px",
                                                gap: "10px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-weight": "bold",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " relevant associations (" +
                                                      _vm._s(
                                                        mechanism.associations
                                                          .length
                                                      ) +
                                                      ") "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    height:
                                                      "calc(225px + 1rem)",
                                                  },
                                                },
                                                [
                                                  _c("b-table", {
                                                    staticStyle: {
                                                      "font-size": "0.9em",
                                                    },
                                                    attrs: {
                                                      small: "",
                                                      "sticky-header": "225px",
                                                      items:
                                                        mechanism.associations,
                                                      fields: [
                                                        "phenotype",
                                                        {
                                                          key: "gene_set_label",
                                                          label: "Gene Set",
                                                        },
                                                        {
                                                          key: "beta_uncorrected",
                                                          label:
                                                            "Gene Set Effect",
                                                        },
                                                        {
                                                          key: "source_label",
                                                          label: "Source",
                                                        },
                                                        "actions",
                                                      ],
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "cell(beta_uncorrected)",
                                                          fn: function (row) {
                                                            return [
                                                              row.item
                                                                .beta_uncorrected <
                                                              0.1
                                                                ? _c("div", [
                                                                    _vm._v(
                                                                      "low (" +
                                                                        _vm._s(
                                                                          row
                                                                            .item
                                                                            .beta_uncorrected
                                                                        ) +
                                                                        ")"
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                              row.item
                                                                .beta_uncorrected >=
                                                                0.1 &&
                                                              row.item
                                                                .beta_uncorrected <
                                                                1
                                                                ? _c("div", [
                                                                    _vm._v(
                                                                      "moderate (" +
                                                                        _vm._s(
                                                                          row
                                                                            .item
                                                                            .beta_uncorrected
                                                                        ) +
                                                                        ")"
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                              row.item
                                                                .beta_uncorrected >=
                                                              1
                                                                ? _c("div", [
                                                                    _vm._v(
                                                                      "strong (" +
                                                                        _vm._s(
                                                                          row
                                                                            .item
                                                                            .beta_uncorrected
                                                                        ) +
                                                                        ")"
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                            ]
                                                          },
                                                        },
                                                        {
                                                          key: "cell(actions)",
                                                          fn: function (row) {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    display:
                                                                      "flex",
                                                                    "flex-direction":
                                                                      "column",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "white-space":
                                                                            "nowrap",
                                                                        },
                                                                      attrs: {
                                                                        href: _vm.getsetLink(
                                                                          row.item
                                                                        ),
                                                                        target:
                                                                          "_blank",
                                                                        disabled:
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "View Geneset"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      attrs: {
                                                                        role: "button",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          row.toggleDetails,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          row.detailsShowing
                                                                            ? "Hide Genes"
                                                                            : "Show Genes"
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                        {
                                                          key: "row-details",
                                                          fn: function (row) {
                                                            return [
                                                              _c(
                                                                "b-card",
                                                                {
                                                                  attrs: {
                                                                    "body-class":
                                                                      "p-2",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-table",
                                                                    {
                                                                      attrs: {
                                                                        small:
                                                                          "",
                                                                        items:
                                                                          row
                                                                            .item
                                                                            .genes,
                                                                        fields:
                                                                          [
                                                                            "gene",
                                                                            {
                                                                              key: "combined",
                                                                              label:
                                                                                "Combined",
                                                                            },
                                                                            {
                                                                              key: "log_bf",
                                                                              label:
                                                                                "GWAS Support",
                                                                            },
                                                                            {
                                                                              key: "prior",
                                                                              label:
                                                                                "Gene Set Support",
                                                                            },
                                                                          ],
                                                                        "head-variant":
                                                                          "light",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-direction": "column",
                                                padding: "5px",
                                                gap: "10px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-weight": "bold",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "contributing CFDE programs"
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    gap: "5px",
                                                    "flex-wrap": "wrap",
                                                  },
                                                },
                                                _vm._l(
                                                  mechanism.programs,
                                                  function (program) {
                                                    return _c(
                                                      "span",
                                                      { staticClass: "pill" },
                                                      [_vm._v(_vm._s(program))]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            padding: "5px",
                                            height: "fit-content",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-size": ".8em",
                                                "font-weight": "bold",
                                                padding: "3px 0",
                                              },
                                            },
                                            [_vm._v("rationale")]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-size": "0.9em",
                                                background:
                                                  "rgb(251, 228, 186)",
                                                padding: "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(mechanism.justification)
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "flex-direction": "column",
                                        padding: "20px",
                                        "margin-top": "auto",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-size": ".8em",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [_vm._v("next steps")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            gap: "10px",
                                          },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "btn btn-info",
                                              staticStyle: {
                                                flex: "1",
                                                color: "white !important",
                                                padding: "10px",
                                              },
                                              attrs: {
                                                href: _vm.genesLink(mechanism),
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "explore genes from this hypothesis"
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "btn btn-primary",
                                              staticStyle: {
                                                flex: "1",
                                                color: "white !important",
                                                padding: "10px",
                                              },
                                              attrs: {
                                                href: _vm.validationLink(
                                                  mechanism
                                                ),
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "plan a validation experiment"
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]),
    _c("svg", { attrs: { id: "lines" } }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticStyle: { display: "none" } }, [
      _c(
        "div",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "bold",
            "line-height": "1em",
          },
        },
        [_vm._v("CFDE REVEAL")]
      ),
      _c(
        "div",
        { staticStyle: { "font-size": "1.2em", "font-weight": "bold" } },
        [_vm._v("Turn your research question into mechanistic leads")]
      ),
      _c("div", { staticStyle: { width: "450px", margin: "5px 0 0" } }, [
        _vm._v("Explore gene expression signatures linked to phenotypes, "),
        _c("br"),
        _vm._v(
          "and get evidence-backed hypotheses about the biology behind them."
        ),
      ]),
      _c("div", [
        _c(
          "a",
          {
            attrs: {
              role: "button",
              onClick:
                "alert('TODO: documentation about the data, associations, and methods')",
            },
          },
          [_vm._v("Learn more")]
        ),
        _vm._v("."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", [
      _c("div"),
      _c("div", [
        _vm._v(
          "You don't need to sift through keywords or ontologies in order to get going."
        ),
      ]),
      _c("div", [
        _vm._v(
          "We extract terms, research context, and suggest related CFDE programs to provide tailored results."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticStyle: { "font-size": "1.2em" } }, [
      _c("strong", [_vm._v("Action:")]),
      _vm._v(" Extracting research criteria based on your query."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticStyle: { display: "flex", "align-items": "center" } },
      [
        _c(
          "div",
          { staticStyle: { "font-size": "1.2em", "font-weight": "bold" } },
          [_vm._v("The values below will be used to inform subsequent steps")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", [
      _c("div", [
        _vm._v(
          "An expert LLM reviews the data and proposes mechanistic hypotheses in the context of your research."
        ),
      ]),
      _c("div", [
        _vm._v(
          "You can explore or validate the results with access to the underlying source data."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticStyle: { "font-size": "1.2em" } }, [
      _c("strong", [_vm._v("Action:")]),
      _vm._v(" Loading genes for "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticStyle: { "font-size": "1.2em" } }, [
      _c("strong", [_vm._v("Action:")]),
      _vm._v(" Generating mechanistic hypotheses "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }